import { render, staticRenderFns } from "./Berlinale2025.vue?vue&type=template&id=e34232b0&scoped=true"
import script from "./Berlinale2025.vue?vue&type=script&lang=js"
export * from "./Berlinale2025.vue?vue&type=script&lang=js"
import style0 from "./Berlinale2025.vue?vue&type=style&index=0&id=e34232b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34232b0",
  null
  
)

export default component.exports